import {Injectable} from '@angular/core';
import {SettingsService} from './settings.service';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {
  AbstractMapConfigProvider,
  CesiumIonLayerConfig,
  CesiumIonTileSubLayerConfig,
  LayerConfig,
  MapConfig,
  PointImpl,
  XYZLayerConfig
} from '@ax/ax-angular-map-common';
import {uuidv4} from "../utils/uuid";



const defaultMapConfig = (() => {
  const ret: LayerConfig[] = [
    new XYZLayerConfig(
      'USGSImageryTopo',
      'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}',
      ''
    ),
    new CesiumIonLayerConfig(
      uuidv4(),
      'Cesium Ion',
      // eslint-disable-next-line max-len
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIwZTc2OTZlNi03Y2FkLTQyNmYtODI3NS02YjhlMGEzZGVmNTAiLCJpZCI6NDM4MDksImlhdCI6MTYxMzY4NDM5N30.z4JK_7tzoBByk1-MrTZkHr7L6YjquRMyWIzfPoIKueE',
      [
        new CesiumIonTileSubLayerConfig('1', 'Cesium World Terrain', 'terrain'),
        new CesiumIonTileSubLayerConfig('2', 'Bing Maps Aerial', 'imagery'),
        new CesiumIonTileSubLayerConfig('3', 'Bing Maps Aerial with Labels', 'imagery'),
        new CesiumIonTileSubLayerConfig('4', 'Bing Maps Road', 'imagery'),
        new CesiumIonTileSubLayerConfig('3845', 'Blue Marble Next Generation July, 2004', 'imagery')
      ]
    )
  ];

  const defaultBounds = {
    nw: new PointImpl(43.26508131632468, -75.50405502319336),
    ne: new PointImpl(43.26508131632468, -75.32793045043944),
    se: new PointImpl(43.17989530238948, -75.32793045043944),
    sw: new PointImpl(43.17989530238948, -75.50405502319336)
  };
  return new MapConfig(ret,
    'USGSImageryTopo', // 'Cesium Ion - 3',
    'Cesium Ion - 3845',
    new PointImpl(43.2219462, -75.4200271),
    {
      type: 'Polygon', coordinates: [[
        defaultBounds.nw.coordinates,
        defaultBounds.ne.coordinates,
        defaultBounds.se.coordinates,
        defaultBounds.sw.coordinates
      ]
      ]
    });
})();


@Injectable({
  providedIn: 'root'
})
export class EnvMapConfigProviderService extends AbstractMapConfigProvider {
  constructor(private envService: SettingsService) {
    super();
  }

  getTileLayerConfigurations(): Observable<MapConfig> {
    return this.envService.getMapConfig().pipe(map(setting => {
      if (!setting) {
        const defaultBounds = {
          nw: new PointImpl(43.26508131632468, -75.50405502319336),
          ne: new PointImpl(43.26508131632468, -75.32793045043944),
          se: new PointImpl(43.17989530238948, -75.32793045043944),
          sw: new PointImpl(43.17989530238948, -75.50405502319336)
        };
        return new MapConfig([],
          null,
          null,
          new PointImpl(43.2219462, -75.4200271),
          {
            type: 'Polygon', coordinates: [[
              defaultBounds.nw.coordinates,
              defaultBounds.ne.coordinates,
              defaultBounds.se.coordinates,
              defaultBounds.sw.coordinates
            ]
            ]
          });
      }
      return setting;
    }));
  }
}
